import { AxiosResponse } from "axios"
import ICampaignService from "./ICampaignService"
import {ENDPOINT} from "../Axios/Api"
import { Client } from "../Axios"
import { clearServerMessage, renderServerMessage } from "@apps/Shared/Utils/ServerMessage";
import i18n from "i18next";

class CampaignService implements ICampaignService {
    async GetAssociationToplist(year: string) {
        let res: AxiosResponse;
        
        try {
            res = await Client('get', `${ENDPOINT.Campaign.AssociationToplist(year)}`);
            clearServerMessage();
        }
        catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }
        
        return res;
    }

    async CheckEan(ean: string): Promise<AxiosResponse> {
         let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.Campaign.CheckEan(ean)}`);
            clearServerMessage();
        } catch (error: any) {
            console.error("Error:", error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }
        return res;
    }
}

export default new CampaignService();